module.exports = __webpack_public_path__ + "static/media/virtual-assistant.c95c6d71.svg";